


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import Dialog1Detail from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box6/dialog-1-1.vue';

@Component({
  components: { Dialog1Detail },
})
export default class Dialog1 extends Vue {
  private dialogVisible: any = false;
  private tableData: any = [];

  total: any = 0;
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  filterForm: any = {
    deptId: '',
  };

  showDialog(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.filterForm.deptId = data.deptId ? data.deptId : '';
    this.getData();
    this.dialogVisible = true;
  }

  getData() {
    zyScreenServer
      .getSecurityCheckNumList({
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        inspectedUnitId: this.filterForm.deptId,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
        throw error;
      });
  }
  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }
  showDetail(item: any) {
    const refName = 'Dialog1Detail';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }
  handleClose(done: any) {
    done();
  }
}
